/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedUspContractTypeDropdownQueryResponse,
  GetApiV1PersonSharedUspContractTypeDropdown401,
  GetApiV1PersonSharedUspContractTypeDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedUspContractTypeDropdown.ts";

function getGetApiV1PersonSharedUspContractTypeDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/usp-contract-type-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todas as opções do enumerador EUspContractType para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de tipos de contrato USP para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/usp-contract-type-dropdown}
 */
export async function getApiV1PersonSharedUspContractTypeDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedUspContractTypeDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedUspContractTypeDropdown401
      | GetApiV1PersonSharedUspContractTypeDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedUspContractTypeDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
